import React from 'react';

interface AnimationTypographyProps {
  className?: string;
  children?: React.ReactNode;
  distance: string;
  delay: string;
  type: 'fade-in-up' | 'fade-in-down' | 'fade-in-left' | 'fade-in-right' | 'fade-in-up-left' | 'fade-in-up-right' | 'fade-in-down-left' | 'fade-in-down-right';
  once?: boolean;
  as?: keyof JSX.IntrinsicElements;
}

const AnimationTypography = ({ className, children, distance, delay, type = 'fade-in-up', once = false, as = 'p' }: AnimationTypographyProps) => {
  const isOnce = once ? 'animate-once' : '';
  const Component = as;
  return <Component className={`${className} animate-${type} ${isOnce} --animation-distance: ${distance} [animation-delay:${delay}ms] whitespace-pre-line`}>{children}</Component>;
};

export default AnimationTypography;
